<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>在线作业</span><i class="el-icon-arrow-right"></i>&nbsp;<span>作业详情</span>
		</div>
		<div class="content" v-loading="loading" :element-loading-text="loadingtext">
			<div class="listTitle">
				<i class="el-icon-s-management"></i> {{taskinfo.name}}（共{{taskinfo.topicNum}}道题，共{{taskinfo.sumScore}}分，及格分：{{taskinfo.passScore}}分）
			</div>
			<div class="course-info-main clearfix ">
				<div class="qusetion-wrap clearfix">
					<div class="qusetion-wrapleft">
						<div v-for="(item,index) in qusetionlist" :class="(item.topicType == 1||item.topicType == 3)?'table-wrap single':'table-wrap'" v-show="questionindex == index">
							<div class="questionTitle">
								{{index+1}}、
								<span v-if="item.topicType == 4">
									{{item.question | spliceQuestion}}
								</span>
								<span v-if="item.topicType != 4">
									{{item.question}}
								</span>
								<span class="maincolor">
									（<span v-if="item.topicType == 1">单选题</span>
								<span v-if="item.topicType == 2">多选题</span>
								<span v-if="item.topicType == 3">判断题</span>
								<span v-if="item.topicType == 4">填空题</span>
								<span v-if="item.topicType == 5">简答题</span>， {{item.score}}分）
								</span>
								<div v-if="item.isFile == '1'" class="filebox" style="margin: 20px 0 0 0;">
									<div class="fileboxname">图片/视频：</div>
									<div>
										<span :key='file.id' v-for="(file,fileindex) in item.files">
											<video style="width: 150px; height: 150px" :src="baseurl + file.url" v-if="file.url.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image fit="fill" style="width: 150px; height: 150px" :src="baseurl + file.url" :preview-src-list="[baseurl + file.url]" v-else>
											</el-image>
										</span>
									</div>
								</div>
							</div>
							<div v-if="item.topicType == 1">
								<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
									<div class="questionLabel">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
									</span>
								</div>
							</div>
							<div v-if="item.topicType == 2">
								<!--Multiple-->
								<div class="questionAnswers" @click="multipleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
									<div class="questionLabel">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
									</span>
								</div>
							</div>
							<div v-if="item.topicType == 3">
								<div class="questionAnswers" @click="singleAnswer(it,i,index)" v-for="(it,i) in item.answerlist">
									<div class="questionLabel">
										<div :class="item.choose.indexOf(it.label) != -1?'outCircle outCircleSelcet':'outCircle'">
											<div class="inCircle"></div>
										</div>
									</div>
									<span>
										{{it.label}}、
										<span v-if="it.type == '1'">{{it.value}}</span>
									<span v-if="it.type == '2'" @click.stop>
											<br />
											<video style="width: 150px; height: 150px" :src="baseurl+it.value" v-if="it.value.indexOf('.mp4')>-1" controls="controls" muted="muted"></video><el-image :key='i' fit="fill" style="width: 100px; max-height: 100px" :src="baseurl+it.value" :preview-src-list="[baseurl+it.value]" v-else></el-image>
										</span>
									</span>
								</div>
							</div>
							<div v-if="item.topicType == 4">
								<el-input placeholder="请输入答案" v-model="item.userAnswer" @input="blanksAnswer(index)">
								</el-input>
							</div>
							<div v-if="item.topicType == 5">
								<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="item.userAnswer" @input="blanksAnswer(index)">
								</el-input>
								<div class="fileArrbox" v-if="item.filearr.length>0">
									<div class="uploadFile" @click.stop="formPreview(file)" v-for="(file,index) in item.filearr">
										<img src="@/images/word.png" />
										<div class="p1">
											{{file.name}}
										</div>
										<div class="p2">
											{{file.size | filesize}}
										</div>
										<i class="el-icon-close closeFile" @click.stop="formFileRemove(file)"></i>
									</div>
									<div style="clear: both;"></div>
								</div>
							</div>
							<div class="questionFooter">
								<el-button @click='prveQuestion' type="primary" size="small" icon="el-icon-arrow-left" :disabled='questionindex<=0'>上一题</el-button>
								<el-button @click='nextQuestion' type="primary" size="small" :disabled='questionindex>=qusetionlist.length-1'>下一题<i class="el-icon-arrow-right el-icon--right"></i></el-button>
								<el-button @click='uploadAnswer' type="primary" size="small" :disabled='uploadFlag' style='float: right;' v-show="item.topicType == 5">
									{{uploadFlag?'正在上传 ':'上传附件'}}
								</el-button>
							</div>
						</div>
					</div>
					<div v-show="false">
						<el-upload :action="action" :limit='1' :multiple='false' :with-credentials='true' accept='.doc,.docx,.mp4,.mp3,.wav' name='file' :file-list="answer_files" :http-request="formRequest">
							<i class="el-icon-plus uploadBox"></i>
						</el-upload>
					</div>
					<div class="asideOther r">
						<div class="table-wrap">
							<dl class="questionCard">
								<dt>当前进度</dt>
								<dd class="autowrap">{{questionove.length}} / {{qusetionlist.length}} </dd>
							</dl>
							<dl class="questionCard">
								<dt>答题卡</dt>
								<dd class="autowrap clearfix">
									<div :class="questionWhere(index)" v-for="(item,index) in qusetionlist.length" @click="jumpQuestion(index)">
										{{index+1}}
									</div>
								</dd>
							</dl>
							<dl class="questionCard">
								<el-button type="primary" @click='overitem'>提交</el-button>
							</dl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="viewName==''?'预览':viewName" :visible.sync="viewShow" append-to-body>
			<div class="viewIframe" v-if="viewShow" v-loading="viewShowLoading">
				<iframe :src="playUrl" v-if="!viewAideoShow"  @load="viewShowLoading = false"></iframe>
				<audio :src="playUrl" v-if="viewAideoShow" controls="controls"></audio>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { taskTopic, taskCommit, getTaskById } from '@/api/task.js'
	import { putProgress } from '@/utils/oss.js'
	export default {
		name: 'task',
		data() {
			return {
				taskId: '',
				loading: true,
				loadingtext: '题目加载中...',
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
				taskinfo: {},
				//文件
				playUrl: '',
				viewName: '',
				viewShowLoading: true,
				viewShow: false,
				viewAideoShow: false,
				viewopen: window.config.VUE_PDF_FILE,
				action: '',
				uploadFlag: false,
				uploadPercent: '0%',
				answer_files: [],
				uploadDate: {

				},
			}
		},
		created() {
			var taskId = this.$route.query.taskId;
			if(taskId) {
				this.taskId = taskId;
				this.getTaskinfo();
				this.getTaskitem();
			}
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			uploadAnswer() {
				$('.uploadBox').click()
			},
			get_name(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(0, pos)
				}
				return suffix
			},
			formRequest(files) {
				this.uploadFlag = true;
				var qusetionlist = this.qusetionlist;
				var questionindex = this.questionindex;
				const file = files.file;
				const key = `cdzy/selftask/${this.getUUID()}${this.get_suffix(file.name)}`;
				putProgress(key, file).then(res => {
					this.uploadFlag = false;
					var fileSize = file.size;
					var fileName = file.name;
					var data = {
						name: fileName,
						size: fileSize,
						url: key,
					}
					var filearr = [data];
					qusetionlist[questionindex].filesurl = JSON.stringify(filearr);
					qusetionlist[questionindex].filearr = filearr;
					qusetionlist[questionindex].over = true;
					this.checkOver();
					this.formFileClear();
				});
			},
			get_suffix(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(pos)
				}
				return suffix
			},
			getUUID() {
				return  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
					let  r = Math.random() * 16 | 0,
						v = c ==  'x'  ? r : (r & 0x3 | 0x8);
					return  v.toString(16);    
				});
			},
			formFileClear() {
				this.answer_files = [];
				this.uploadFlag = false;
				this.uploadPercent = '0%';
			},
			formFileRemove(file) {
				var questionindex = this.questionindex;
				var qusetionlist = this.qusetionlist;
				qusetionlist[questionindex].filesurl = '';
				qusetionlist[questionindex].filearr = [];
				if(qusetionlist[questionindex].userAnswer.length <= 0) {
					qusetionlist[questionindex].over = false
				}
				this.checkOver();
			},
			formPreview(file) {
				var url = file.url;
				var filetype = file.url.substring(file.url.lastIndexOf('.') + 1);
				this.viewAideoShow = false;
				if(filetype == 'doc' || filetype == 'docx') {
					var playUrl = this.baseurl + url;
					playUrl = this.viewopen + encodeURIComponent(window.btoa(playUrl));
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					this.viewShowLoading = true;
				} else {
					var playUrl = this.baseurl + url;
					this.playUrl = playUrl;
					this.viewName = file.name;
					this.viewShow = true;
					if(filetype == 'mp3' || filetype == 'wav'){
						this.viewAideoShow = true;
					}
				}
			},
			getTaskitem() {
				var data = {
					id: this.taskId
				}
				getTaskById(data).then(res => {
					if(res.code == 0 && res.data) {
						this.taskinfo = res.data;
						if(res.data.is_finish) {
							this.$message.info('作业已提交');
							this.$router.back(-1)
						}
					}
				})
			},
			getTaskinfo() {
				var data = {
					taskId: this.taskId
				}
				taskTopic(data).then(res => {
					if(res.code == 0) {
						this.qusetionlist = res.data;
						this.formInit()
					}
				})
			},
			overitem() {
				if(!this.uploadFlag) {
					var qusetionlist = this.qusetionlist;
					var questionove = this.questionove;
					if(questionove.length == qusetionlist.length) {
						this.loading = true;
						this.loadingtext = '正在提交...';
						var data = {
							taskId: this.taskId,
							userAnswers: []
						}
						qusetionlist.map(item => {
							var userAnswer = {
								topicId: item.id,
								userAnswerFile: item.filesurl,
								userAnswer: "",
							}
							if(item.topicType == 4 || item.topicType == 5) {
								userAnswer.userAnswer = item.userAnswer
							} else {
								userAnswer.userAnswer = item.choose.join('')
							}

							data.userAnswers.push(userAnswer)
						})
						taskCommit(data).then(res => {
							this.loading = false;
							if(res.code == 0) {
								this.$message.success('提交成功');
								this.$router.back(-1);
							}
						}).catch(err => {
							this.loading = false;
						})
					} else {
						this.$message.error('还有未完成的题目')
					}
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			formInit() {
				var qusetionlist = this.qusetionlist;
				qusetionlist.map(item => {
					item.over = false;
					item.choose = [];
					item.filesurl = '';
					item.filearr = [];
					item.userAnswer = '';
					if(item.isFile == 1 && item.fileName != null) {
						var files = JSON.parse(item.fileName);
						item.files = files;
						var openfiles = [];
						files.map(item => {
							var openurl = this.baseurl + item.url;
							openfiles.push(openurl)
						})
						item.openfiles = openfiles;
					}
					var answerlist = [];
					if(item.optionA != '' && item.optionA != null) {
						if(item.optionA.indexOf('@') == -1) {
							answerlist[0] = {
								type: '1',
								label: 'A',
								value: item.optionA,
							}
						} else {
							answerlist[0] = {
								type: '2',
								label: 'A',
								value: item.optionA.slice(1),
							}
						}
					}
					if(item.optionB != '' && item.optionB != null) {
						if(item.optionB.indexOf('@') == -1) {
							answerlist[1] = {
								type: '1',
								label: 'B',
								value: item.optionB,
							}
						} else {
							answerlist[1] = {
								type: '2',
								label: 'B',
								value: item.optionB.slice(1),
							}
						}
					}
					if(item.optionC != '' && item.optionC != null) {
						if(item.optionC.indexOf('@') == -1) {
							answerlist[2] = {
								type: '1',
								label: 'C',
								value: item.optionC,
							}
						} else {
							answerlist[2] = {
								type: '2',
								label: 'C',
								value: item.optionC.slice(1),
							}
						}
					}
					if(item.optionD != '' && item.optionD != null) {
						if(item.optionD.indexOf('@') == -1) {
							answerlist[3] = {
								type: '1',
								label: 'D',
								value: item.optionD,
							}
						} else {
							answerlist[3] = {
								type: '2',
								label: 'D',
								value: item.optionD.slice(1),
							}
						}
					}
					if(item.optionE != '' && item.optionE != null) {
						if(item.optionE.indexOf('@') == -1) {
							answerlist[4] = {
								type: '1',
								label: 'E',
								value: item.optionE,
							}
						} else {
							answerlist[4] = {
								type: '2',
								label: 'E',
								value: item.optionE.slice(1),
							}
						}
					}
					if(item.optionF != '' && item.optionF != null) {
						if(item.optionF.indexOf('@') == -1) {
							answerlist[5] = {
								type: '1',
								label: 'F',
								value: item.optionF,
							}
						} else {
							answerlist[5] = {
								type: '2',
								label: 'F',
								value: item.optionF.slice(1),
							}
						}
					}
					item.answerlist = answerlist;
				})
				this.qusetionlist = qusetionlist;
				setTimeout(_ => {
					this.loading = false;
				}, 600)
			},
			questionWhere(index) {
				var questionindex = this.questionindex;
				var questionove = this.questionove;
				if(index == questionindex) {
					return 'questionAnswer doing'
				} else if(questionove.indexOf(index) != -1) {
					return 'questionAnswer over'
				} else {
					return 'questionAnswer'
				}
			},
			singleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				var choose = [it.label];
				qusetionlist[index].choose = choose;
				qusetionlist[index].over = true;
				this.qusetionlist = qusetionlist;
				this.checkOver();
			},
			multipleAnswer(it, i, index) {
				var qusetionlist = this.qusetionlist;
				var choose = qusetionlist[index].choose;
				if(choose.indexOf(it.label) == -1) {
					choose.push(it.label)
				} else {
					var deleteIndex = choose.indexOf(it.label);
					choose.splice(deleteIndex, 1)
				}
				choose = choose.sort();
				qusetionlist[index].choose = choose;
				if(choose.length > 0) {
					qusetionlist[index].over = true;
				} else {
					qusetionlist[index].over = false;
				}
				this.qusetionlist = qusetionlist;
				this.checkOver();
			},
			blanksAnswer(index) {
				var qusetionlist = this.qusetionlist;
				if(qusetionlist[index].userAnswer.length > 0) {
					qusetionlist[index].over = true;
				} else {
					qusetionlist[index].over = false;
				}
				this.checkOver();
			},
			checkOver() {
				var qusetionlist = this.qusetionlist;
				var questionove = [];
				qusetionlist.map((item, index) => {
					if(item.over == true) {
						questionove.push(index)
					}
				})
				this.questionove = questionove;
			},
			jumpQuestion(questionindex) {
				if(!this.uploadFlag) {
					if(this.questionindex != questionindex) {
						this.questionindex = questionindex
					}
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			prveQuestion() {
				if(!this.uploadFlag) {
					this.questionindex--;
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			nextQuestion() {
				if(!this.uploadFlag) {
					this.questionindex++;
				} else {
					this.$message.info('正在上传文件。。。')
				}
			},
			touserCenter(type) {
				if(this.$route.name != 'user') {
					this.$router.push({
						name: 'user',
						query: {
							type: type,
						}
					})
				}
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
	}
</script>